<div class="fondo">
  <nav mat-tab-nav-bar class="microapp tab navBar" mat-align-tabs="center">
    <a class="tabLabel" mat-tab-link [routerLink]="['../conf/pases']"
      routerLinkActive>{{'MAPP-HVAC.FACILITY.TABS.PASSES' | translate}}</a>
  </nav>
  <router-outlet></router-outlet>
</div>